document.addEventListener("DOMContentLoaded", function(){

const sizeSelector = document.querySelector("#size-selector");
const bundleCards = document.querySelectorAll(".bundle-card");

let selectedSize = sizeSelector.value;
let selectedBundle = "1";


function changeVariant(){

const variant = window.productVariants.find(function(v){

return (
v.option1 == selectedSize &&
v.option2 == selectedBundle
);

});


if(!variant){
console.log("No variant found");
return;
}


console.log("Changing to", variant);


// Change variant ID

const variantInput =
document.querySelector('input[name="id"]');


if(variantInput){

variantInput.value = variant.id;

}



// Change price

const price =
document.querySelector(".price-item--regular");


if(price){

price.innerHTML =
Shopify.formatMoney(
variant.price,
"{{ shop.money_format }}"
);

}



}



sizeSelector.addEventListener("change",function(){

selectedSize=this.value;

changeVariant();

});



bundleCards.forEach(function(card){

card.addEventListener("click",function(){


bundleCards.forEach(c=>{
c.classList.remove("active");
});


this.classList.add("active");


selectedBundle =
this.dataset.bundle;


changeVariant();


});


});


});